import { forwardRef } from 'react';
import { Box, ButtonBase, makeStyles, Typography } from '@material-ui/core';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { DropDownIcon, DropUpIcon } from '../../../../components/Icon';
import { statusP } from '../../bsApp';
import RemaksIcon from '../../components/BedStatusIcon/RemaksIcon';
import BottonStatusIcon from '../../components/BedStatusIcon/BottonStatusIcon';

const useStyles = makeStyles(() => ({
  barBtn: {
    padding: '0.5rem 2rem 0.5rem 1.125rem',
    backgroundColor: '#fff',
    borderRadius: '8px 8px 0 0',
    fontFamily: 'NotoSans-Medium',
    color: '#7d86a9',
    fontSize: '1rem',
    boxShadow: '0 -10px 20px 0 rgba(198, 211, 230, 0.4)',
  },
  detailBarBtn: {
    padding: '0.5rem 2rem 0.5rem 1.125rem',
    backgroundColor: '#fff',
    borderRadius: '8px 8px 0 0',
    fontFamily: 'NotoSans-Medium',
    color: '#7d86a9',
    fontSize: '1rem',
    boxShadow: '0 -10px 20px 0 rgba(198, 211, 230, 0.4)',
    position: 'absolute',
    top: '-2.375rem',
    left: 0,
  },
  dropIcon: {
    marginLeft: '1rem',
    fontSize: '0.875rem',
    color: '#538fff',
  },
  root: ({ fullScreen, sso }) => ({
    padding: '0.75rem 1.125rem',
    width: fullScreen || sso ? '100vw' : 'calc(100vw - 6.25rem)',
    backgroundColor: '#fff',
    boxShadow: '0 -10px 20px 0 rgba(198, 211, 230, 0.4)',
    position: 'relative',
  }),
  title: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: '#7d86a9',
  },
  statusBox: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  vacantText: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    fontWeight: '500',
    color: '#2e4469',
    margin: '0 0 0 0.625rem',
  },
}));

const StatusBar = forwardRef(
  ({ open, handleRemarkBar, lastUpdatedTime, handleFilterSelectOption, statusBottom, remarks }, ref) => {
    const fullScreen = useSelector((state) => state.fullScreenReducer);
    const sso = useSelector((state) => state.ssoReducer);
    const classes = useStyles({ fullScreen, sso });

    return (
      <Box ref={ref} zIndex={20} position="absolute" bottom="0" left={fullScreen || sso ? '0' : '6.25rem'}>
        {!open && (
          <ButtonBase id="bs_status_and_remark_btn" className={classes.barBtn} onClick={handleRemarkBar}>
            Status & Remarks
            <DropUpIcon className={classes.dropIcon} />
          </ButtonBase>
        )}
        {open && (
          <div className={classes.root}>
            <ButtonBase id="bs_status_and_remark_btn" className={classes.detailBarBtn} onClick={handleRemarkBar}>
              Status & Remarks
              <DropDownIcon className={classes.dropIcon} />
            </ButtonBase>
            <Box display="flex" justifyContent="space-between" mb="0.375rem">
              <div className={classes.title}>Status</div>
              <div className={classes.title} id="bs_last_update_time_div">
                Last updated time: {lastUpdatedTime ? moment(lastUpdatedTime).format('yyyy-MM-DD HH:mm') : ''}
              </div>
            </Box>
            <Box className={classes.statusBox}>
              {_.map(statusBottom, (item) => {
                return (
                  <ButtonBase
                    style={{ display: 'flex', alignItems: 'center', margin: '0 2.875rem 0 0', padding: '0.5rem 0' }}
                    key={item.typeName}
                    onClick={handleFilterSelectOption(item.typeName)}
                    id={item.idName}
                  >
                    <BottonStatusIcon typeName={item.typeName} />
                    <Typography className={classes.vacantText}>{item.text}</Typography>
                  </ButtonBase>
                );
              })}
            </Box>
            <Box className={classes.title} mb="0.375rem" mt="0.75rem">
              Remarks
            </Box>
            <Box className={classes.statusBox}>
              {_.map(remarks, (item) => {
                return (
                  <ButtonBase
                    style={{ display: 'flex', margin: '0 2.875rem 0 0', padding: '0.5rem 0' }}
                    key={item.typeName}
                    onClick={handleFilterSelectOption(item.typeName)}
                    id={item.idName}
                  >
                    {Object.values(statusP).includes(item.typeName) ? (
                      <BottonStatusIcon typeName={item.typeName} className={classes.remaksIcon} />
                    ) : (
                      <Box display="flex">
                        <RemaksIcon typeName={item.typeName} className={classes.remaksIcon} />
                        {item.typeName2 && (
                          <>
                            <div style={{ fontSize: '1.5rem', margin: '0 0.2rem' }}>/</div>
                            <RemaksIcon typeName={item.typeName2} className={classes.remaksIcon} />
                          </>
                        )}
                      </Box>
                    )}
                    <Typography className={classes.vacantText}>{item.text}</Typography>
                  </ButtonBase>
                );
              })}
            </Box>
          </div>
        )}
      </Box>
    );
  }
);

StatusBar.displayName = 'StatusBar';

export default StatusBar;
